import { IconType } from "react-icons/lib";
import { MdOutlineInfo } from "react-icons/md";

export type HelpButtonProps = {
  text?: string;
  icon?: IconType;
  url?: string;
};

export const HelpButton = (props: HelpButtonProps) => {
  const {
    text = "Need help troubleshooting?",
    icon: Icon = MdOutlineInfo,
    url = "https://help.rutter.com",
  } = props;

  return (
    <div className="flex gap-2 items-center text-sm font-semibold text-gray-500">
      <div className="flex justify-center items-center w-4 h-4 rounded-full">
        <Icon />
      </div>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="transition-colors hover:text-gray-700"
      >
        {text}
      </a>
    </div>
  );
};
